import React, { useEffect } from 'react'
import { Route, useLocation, useNavigate } from 'react-router-dom';
import { Dashboard, MainOutlet, Progress, Standard } from '../pages/Main';

function MainpageRoutes() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const redirectPath = `/main/standard`;

    if (location.pathname === "/main/"||location.pathname === "/main") {
      navigate(redirectPath, { replace: true });
    }
  }, [location.pathname, navigate]);
  return (
    <Route path="main" element={<MainOutlet />}>
        <Route path="standard" element={<Standard />}/>
        <Route path="progress" element={<Progress />}/>
        <Route path="dashboard" element={<Dashboard />}/>
    </Route>
  )
}

export default MainpageRoutes;